import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataService {
  private regenerateCaptchaSubject = new BehaviorSubject<void>(null);
  private verifyCaptchaSubject = new BehaviorSubject<void>(null);
  private messageSource = new BehaviorSubject('first message');
  currentMessage = this.messageSource.asObservable();
  captchaFlag:boolean|null=null;
  newFlagonpageload : boolean = true;
  regenerateCaptcha:boolean|null=null;
  constructor() { }
  changeMessage(message: string) {
    this.messageSource.next(message);
  }
  regenerateCaptcha$ = this.regenerateCaptchaSubject.asObservable();
  verifyCaptcha$ = this.verifyCaptchaSubject.asObservable();
  triggerRegenerateCaptcha() {
    this.regenerateCaptchaSubject.next(null);
  }
  verifyCaptcha(){
    this.verifyCaptchaSubject.next(null)
  }

}
